import { render, staticRenderFns } from "./ReportIssuesMenu.vue?vue&type=template&id=2362d9ac&scoped=true&"
import script from "./ReportIssuesMenu.vue?vue&type=script&lang=ts&"
export * from "./ReportIssuesMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ReportIssuesMenu.vue?vue&type=style&index=0&id=2362d9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362d9ac",
  null
  
)

export default component.exports